<!-- Texture Upload Input for Inspector -->
<script lang="ts">
  import Button from '@/ui/base/Button.svelte';
  import Icon from '@/ui/base/Icon.svelte';

  let {
    value = 'placeholder',
    textureName = null,
    objectId = '',
    onChange,
  }: {
    value: string;
    textureName?: string | null;
    objectId: string;
    onChange?: (texture: string, textureName: string | null) => void;
  } = $props();

  // Local state for reactive updates
  let currentValue = $state(value);
  let currentTextureName = $state(textureName);

  // Sync with props
  $effect(() => {
    currentValue = value;
    currentTextureName = textureName;
  });

  function handleFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    // Check file type
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    // Create blob URL
    const imageUrl = URL.createObjectURL(file);

    currentValue = imageUrl;
    currentTextureName = file.name;

    onChange?.(imageUrl, file.name);
  }

  function handleRemove() {
    // Revoke blob URL if it exists
    if (currentValue && currentValue.startsWith('blob:')) {
      URL.revokeObjectURL(currentValue);
    }

    currentValue = 'placeholder';
    currentTextureName = null;

    onChange?.('placeholder', null);
  }
</script>

<div class="space-y-1">
  {#if currentValue === 'placeholder'}
    <div class="text-xs text-gray-500 bg-gray-800 p-1.5 rounded border border-gray-600">
      No texture loaded
    </div>
  {:else}
    <div class="text-xs text-green-400 bg-gray-800 p-1.5 rounded border border-green-600">
      {currentTextureName || 'Texture loaded'}
    </div>
  {/if}

  <div class="flex gap-1">
    <input
      type="file"
      accept="image/*"
      onchange={handleFileUpload}
      class="hidden"
      id="texture-upload-{objectId}"
    />
    <Button
      variant="secondary"
      size="sm"
      fullWidth={true}
      on:click={() => document.getElementById(`texture-upload-${objectId}`)?.click()}
    >
      <Icon name="upload" size="sm" />
      Upload
    </Button>

    {#if currentValue !== 'placeholder'}
      <Button variant="secondary" size="sm" on:click={handleRemove}>
        <Icon name="trash" size="sm" />
      </Button>
    {/if}
  </div>
</div>
